import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

// Fetch connected social accounts for the given access key
const useGetSocialAccounts = (accessKey) => {
  return useQuery({
    queryKey: ['social-accounts', accessKey],
    queryFn: () => api.fetchSocialAccounts(accessKey),
    enabled: !!accessKey,
    select: (res) => (Array.isArray(res) ? res : res?.data || []),
    retry: false,
  });
};

const useConnectInstagram = () => {
  return useQuery({
    queryKey: ['social', 'connect-instagram'],
    queryFn: api.handleInstagramCallback(),
    enabled: true,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};

const useConnectFacebook = () => {
  return useQuery({
    queryKey: ['social', 'connect-facebook'],
    queryFn: api.handleFacebookCallback(),
    enabled: true,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};
export { useConnectInstagram, useConnectFacebook, useGetSocialAccounts };
